import { FC } from 'react';
import { ProjectTechnologiesTranslation } from './ProjectTechnologiesTypes.ts';
import styles from './ProjectTechnologies.module.scss';
import { Col, Container, Row } from 'react-bootstrap';

/**
 * Props for the ProjectTechnologies component.
 */
interface ProjectTechnologiesProps {
    technologiesTranslation: ProjectTechnologiesTranslation;
}

const ProjectTechnologies: FC<ProjectTechnologiesProps> = (props) => {
    const {
        technologiesTranslation
    } = props;

    const {
        usedTechnologies,
        title,
    } = technologiesTranslation;

    return (
        <div
            className={styles.technologies}
        >
            <h4
                className={styles.technologyTitle}
            >
                {title}
            </h4>
            <Container
                className={styles.technologyList}
            >
                <Row
                    className='d-flex justify-content-around gap-3'
                >
                    {usedTechnologies.map((technology, index) => (
                        <Col
                            sm={3}
                            key={index}
                            className={`text-center ${styles.technologyItem}`}
                        >
                            {technology}
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}

export default ProjectTechnologies;